// extracted by mini-css-extract-plugin
export default {"customizedStatusBarContainer":"CustomizedStatusBar_customizedStatusBarContainer__LXP2Q","item":"CustomizedStatusBar_item__MCsR2"};